import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { Divider } from '@material-ui/core';
import { colors, borderRadius, boxShadows } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: colors.background.grayLight,
    borderRadius: borderRadius.button,
    boxShadow: boxShadows.block,
  },
  section: {
    padding: theme.spacing(2),
  },
  footer: {
    backgroundColor: colors.background.grayCard,
    padding: theme.spacing(2),
  },
}));

export const EditModeCardSection = ({ children, first, className }) => {
  const classes = useStyles();

  return (
    <>
      {!first && <Divider />}
      <section className={cn(classes.section, className)}>{children}</section>
    </>
  );
};

EditModeCardSection.propTypes = {
  children: PropTypes.node.isRequired,
  first: PropTypes.bool,
  className: PropTypes.string,
};

EditModeCardSection.defaultProps = {
  first: false,
  className: '',
};

const EditModeCard = ({ className, children, footer, footerClass }) => {
  const classes = useStyles();

  return (
    <div className={cn(classes.root, className)}>
      {children}
      {footer && (
        <>
          <Divider />
          <div className={cn(classes.footer, footerClass)}>{footer}</div>
        </>
      )}
    </div>
  );
};

EditModeCard.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  footerClass: PropTypes.string,
};

EditModeCard.defaultProps = {
  footer: null,
};

export default memo(EditModeCard);
